<mat-dialog-content class="mat-typography">
  <div class="pdf_liste" *ngFor="let item of data.data | keyvalue">
    <span>Kalenderwoche {{ item.key.split('_')[1].split('-')[1] }} - {{ item.key.split('_')[1].split('-')[0] }}</span>
    <mat-icon id="pdf_icon" (click)="downloadPDF(item)">download</mat-icon>
  </div>
</mat-dialog-content>
